import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
// import Accordion from "react-bootstrap/Accordion";
// import SelectDropdown from "../../components-react/SelectDropdown";
// import { monthsData } from "../../common-data/DropdowData";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";

const IncentiveHistory = ({ rowData }) => {
  const {
    earnings,
    monthly,
    quaterly,
    half_yearly,
    yearly,
    earnings_renewals,
    monthlyRenewals,
    quaterlyRenewals,
    half_yearlyRenewals,
    yearlyRenewals,
  } = rowData?.incentiveHistoryData || {};

  const tablesColumns = [
    {
      dataField: "member_name",
      text: "Member Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.member_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Number",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.mobile || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name" style={{ textTransform: "lowercase" }}>
            {row?.email || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name"
            style={{
              padding: "10px",
              borderRadius: "50px",
              background: "#BCBBF7",
              color: "#000",
            }}
          >
            {row?.plan_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name"
            style={{
              padding: "10px",
              borderRadius: "50px",
              background: "#FFEDC0",
              color: "#000",
            }}
          >
            ₹{row?.price || "0"}
          </p>
        </div>
      ),
    },
    {
      dataField: "payment_status",
      text: "payment status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name"
            style={{
              // padding: "5px",
              // borderRadius: "5px",
              // background: row?.payment_status ? "#C5E898" : "#FA7070",
              // textTransform: "uppercase",
              color: row?.payment_status ? "#379C00" : "#BE3144",
            }}
          >
            {row?.payment_status ? "completed" : "pending" || "N/A"}
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <Tabs>
        <TabList>
          <Tab>Monthly Membership</Tab>
          <Tab>Quarterly Membership</Tab>
          <Tab>Half-Yerly Membership</Tab>
          <Tab>Annual Membership</Tab>
        </TabList>

        <TabPanel>
          <div className="allPtMembersTableContainer insideAccordianTableContainer">
            <div className="horizontallyScrollCardsContainer">
              <div className="cussss renewlaCustomDraggable">
                <div className="cardsCotaier">
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total membership</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? earnings?.monthly?.total_memberships
                          : earnings_renewals?.monthly?.total_memberships || 0}
                      </p>
                    </div>
                    {/* <div className="oneSideCard rigth"></div> */}
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Incentive Value</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.monthly?.value_per * 100 || 0
                            )?.toFixed(2)
                          : parseFloat(
                              earnings_renewals?.monthly?.value_per * 100 || 0
                            )?.toFixed(2)}
                        %
                      </p>
                    </div>
                    {/* <div className="oneSideCard rigth"></div> */}
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Total sale value</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.monthly?.plan_value || 0
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.monthly?.plan_value || 0
                            ).toFixed(2)}
                      </p>
                    </div>
                    {/* <div className="oneSideCard rigth"></div> */}
                  </div>
                  <div
                    className="cardBox bgGreen"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total earnings</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.monthly?.total_earning
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.monthly?.total_earning
                            ).toFixed(2) || 0}
                      </p>
                    </div>
                    {/* <div className="oneSideCard rigth"></div> */}
                  </div>
                </div>
              </div>
            </div>

            <PayoutsTable
              columnsValues={tablesColumns}
              dataValues={
                rowData?.tabName === "rewards" ? monthly : monthlyRenewals
              }
            />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="allPtMembersTableContainer insideAccordianTableContainer">
            <div className="horizontallyScrollCardsContainer">
              <div className="cussss renewlaCustomDraggable">
                <div className="cardsCotaier">
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total membership</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? earnings?.quaterly?.total_memberships
                          : earnings_renewals?.quaterly?.total_memberships || 0}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Incentive Value</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.quaterly?.value_per * 100 || 0
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.quaterly?.value_per * 100 || 0
                            ).toFixed(2)}
                        %
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Total sale value</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.quaterly?.plan_value || 0
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.quaterly?.plan_value || 0
                            ).toFixed(2)}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgGreen"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total earnings</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.quaterly?.total_earning
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.quaterly?.total_earning
                            ).toFixed(2) || 0}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                </div>
              </div>
            </div>

            <PayoutsTable
              columnsValues={tablesColumns}
              dataValues={
                rowData?.tabName === "rewards" ? quaterly : quaterlyRenewals
              }
            />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="allPtMembersTableContainer insideAccordianTableContainer">
            <div className="horizontallyScrollCardsContainer">
              <div className="cussss renewlaCustomDraggable">
                <div className="cardsCotaier">
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total membership</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? earnings?.halfYearly?.total_memberships
                          : earnings_renewals?.halfYearly?.total_memberships ||
                            0}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Incentive Value</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.halfYearly?.value_per * 100 || 0
                            )?.toFixed(2)
                          : parseFloat(
                              earnings_renewals?.halfYearly?.value_per * 100 ||
                                0
                            )?.toFixed(2)}
                        %
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Total sale value</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.halfYearly?.plan_value || 0
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.halfYearly?.plan_value || 0
                            ).toFixed(2)}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgGreen"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total earnings</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.halfYearly?.total_earning
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.halfYearly?.total_earning
                            ).toFixed(2) || 0}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                </div>
              </div>
            </div>

            <PayoutsTable
              columnsValues={tablesColumns}
              dataValues={
                rowData?.tabName === "rewards"
                  ? half_yearly
                  : half_yearlyRenewals
              }
            />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="allPtMembersTableContainer insideAccordianTableContainer">
            <div className="horizontallyScrollCardsContainer">
              <div className="cussss renewlaCustomDraggable">
                <div className="cardsCotaier">
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total membership</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? earnings?.yearly?.total_memberships
                          : earnings_renewals?.yearly?.total_memberships || 0}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Incentive Value</span>
                      <p className="totalTag">
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.yearly?.value_per * 100 || 0
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.yearly?.value_per * 100 || 0
                            ).toFixed(2)}
                        %
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgYellow"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">Total sale value</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(
                              earnings?.yearly?.plan_value || 0
                            ).toFixed(2)
                          : parseFloat(
                              earnings_renewals?.yearly?.plan_value || 0
                            ).toFixed(2)}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                  <div
                    className="cardBox bgGreen"
                    style={{ cursor: "not-allowed" }}
                  >
                    <div className="oneSideCard left">
                      <span className="tagName">total earnings</span>
                      <p className="totalTag">
                        ₹
                        {rowData?.tabName === "rewards"
                          ? parseFloat(earnings?.yearly?.total_earning).toFixed(
                              2
                            )
                          : parseFloat(
                              earnings_renewals?.yearly?.total_earning
                            ).toFixed(2) || 0}
                      </p>
                    </div>
                    <div className="oneSideCard rigth"></div>
                  </div>
                </div>
              </div>
            </div>

            <PayoutsTable
              columnsValues={tablesColumns}
              dataValues={
                rowData?.tabName === "rewards" ? yearly : yearlyRenewals
              }
            />
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

export default IncentiveHistory;
